import { RequestsTypesLinks } from '@/services/staticLookups';
import { Route, RouteConfig } from 'vue-router';
import Breadcrumbs from './breadcrumbs';
import { RequestsAndLicensesTab } from '@/enums/tabs';

const RequestsAndLicenses = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "RequestsAndLicenses" */ '@/views/RequestsAndLicenses/requestsAndLicenses');
const ViewRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "NewRequest" */ '@/views/ViewRequest/viewRequest');
const NewRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "NewRequest" */ '@/views/NewRequest/newRequest');
const RenewRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "RenewRequest" */ '@/views/RenewRequest/renewRequest');
const ReregisterRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ReregisterRequest" */ '@/views/ReregisterRequest/reregisterRequest');
const ReissueRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "ReissueRequest" */ '@/views/ReissueRequest/reissueRequest');
const CancelNewRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "CancelRequest" */ '@/views/CancelRequest/NewRequest/newRequest');
const CancelEditOrRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "CancelRequest" */ '@/views/CancelRequest/EditOrViewRequest/editOrViewRequest');
const marriageOfficialGuide = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "marriageOfficialGuide" */ '@/views/MarriageOfficialGuide/marriageOfficialGuide');
const LicenseDetails = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "LicenseDetails" */ '@/views/LicenseDetails/licenseDetails');
const UpdateActions = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "UpdateActions" */ '@/views/UpdateActions/updateActions');
const UpdateLicenseRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "UpdateLicenseRequest" */ '@/views/UpdateLicenseRequest/updateLicenseRequest');
const UpdateNameRequest = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "UpdateNameRequest" */ '@/views/UpdateNameRequest/updateNameRequest');

const routes: Array<RouteConfig> = [
  {
    // ! From /marriage-Official-Licences to /
    path: '/',
    name: 'index',
    redirect: '/requests&licenses',
  },
  {
    path: '/requests&licenses',
    name: 'RequestsAndLicenses',
    component: RequestsAndLicenses,
    props: (route:Route) => ({ activeTab: route.hash ? JSON.parse(route.hash.split('#')[1]) as RequestsAndLicensesTab : '' }),
    meta: {
      breadcrumb: Breadcrumbs.requestsList,
      highlighted: true,
    },
  },
  {
    path: RequestsTypesLinks.viewLicense,
    name: 'LicenseDetails',
    component: LicenseDetails,
    meta: {
      breadcrumb: Breadcrumbs.licenseDetails,
      highlighted: true,
    },
  },
  {
    path: `${RequestsTypesLinks.new}/:id?`,
    component: NewRequest,
    meta: {
      breadcrumb: Breadcrumbs.newRequest,
      highlighted: true,
    },
  },
  {
    path: `${RequestsTypesLinks.renew}/:id?`,
    component: RenewRequest,
    meta: {
      breadcrumb: Breadcrumbs.renewRequest,
      highlighted: true,
    },
  },
  {
    path: `${RequestsTypesLinks.reregister}/:id?`,
    component: ReregisterRequest,
    meta: {
      breadcrumb: Breadcrumbs.reregisterRequest,
      highlighted: true,
    },
  },
  {
    path: `${RequestsTypesLinks.reissueLink}/:id?`,
    component: ReissueRequest,
    meta: {
      breadcrumb: Breadcrumbs.reissueRequest,
      highlighted: true,
    },
  },
  {
    path: `${RequestsTypesLinks.cancel}/:licenseNumber`,
    component: CancelNewRequest,
    meta: {
      breadcrumb: Breadcrumbs.cancelRequest,
      highlighted: true,
    },
  },
  {
    path: `${RequestsTypesLinks.cancelViewOrEdit}/:id`,
    component: CancelEditOrRequest,
    meta: {
      breadcrumb: Breadcrumbs.cancelRequest,
      highlighted: true,
    },
  },
  {
    path: `${RequestsTypesLinks.viewRequest}/:id`,
    component: ViewRequest,
    meta: {
      breadcrumb: Breadcrumbs.viewRequest,
      highlighted: true,
    },
  },
  {
    path: `${RequestsTypesLinks.updateLicense}/:id?`,
    component: UpdateLicenseRequest,
    meta: {
      breadcrumb: Breadcrumbs.updateLicenseRequest,
      highlighted: true,
    },
  },
  {
    path: `${RequestsTypesLinks.updateName}/:id?`,
    component: UpdateNameRequest,
    meta: {
      breadcrumb: Breadcrumbs.updateNameRequest,
      highlighted: true,
    },
  },
  {
    path: '/update/:updateType?',
    component: UpdateActions,
    props: true,
    meta: {
      breadcrumb: Breadcrumbs.updateActions,
      highlighted: true,
    },
  },

  {
    // ! From ---> /marriageOfficialGuide to /guide
    path: '/guide',
    name: 'marriageOfficialGuide',
    component: marriageOfficialGuide,
    meta: {
      highlighted: true,
      breadcrumb: Breadcrumbs.marriageOfficialGuide,
    },
  },
];

export default routes;
